export const DISPENSE_TYPE_NONE = 0;
export const DISPENSE_PROVIDER_POSWORKS = 1;
export const DISPENSE_PROVIDER_MINFOS = 2;
export const DISPENSE_PROVIDER_ZDISPENSE = 3;
export const DISPENSE_PROVIDER_CORUM = 4;
export const DISPENSE_PROVIDER_POSWORKS_IP = 5;
export const DISPENSE_PROVIDER_FRED_CLASSIC = 6;
export const DISPENSE_PROVIDER_FRED_NEXT = 7;

export const DISPENSE_SYSTEM_NAMES = Object.freeze({
  [DISPENSE_TYPE_NONE]: '',
  [DISPENSE_PROVIDER_POSWORKS]: 'Posworks',
  [DISPENSE_PROVIDER_MINFOS]: 'Minfos',
  [DISPENSE_PROVIDER_ZDISPENSE]: 'zDispense',
  [DISPENSE_PROVIDER_CORUM]: 'Corum',
  [DISPENSE_PROVIDER_POSWORKS_IP]: 'Dispense Works',
  [DISPENSE_PROVIDER_FRED_CLASSIC]: 'Fred Classic',
  [DISPENSE_PROVIDER_FRED_NEXT]: 'Fred Plus',
});

export function dispenseSystemName(dispenseType) {
  if (dispenseType == null) return '';
  return DISPENSE_SYSTEM_NAMES[Number(dispenseType)] ?? '';
}
